<template>
    <div class="form-covid" v-if="form != null">
        <form class="form_call">
            <div class="form-in" :class="{fadeOut : !formVisible}" v-if="formVisible">
                <div class="form-group">
                    <div class="city-info-select">
                        <select id="select-city">
                            <option :value="index" v-for="(item, index) in cityArr" :key="index">
                                {{item.city}}
                            </option>
                        </select>
                        <svg-icon icon-class="calendar" className="icon-calendar"/>
                        <div class="icon-elem">
                            <svg-icon icon-class="down-arrow" className="icon-down-arrow"/>
                        </div>
                    </div>
                </div>
                <div class="form-group form-text">
                    <input type="text" name="name" class="form-control" :placeholder="form.name_mask" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                </div>
                <div class="form-group form-phone">
                    <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" :placeholder="form.phone_mask" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                </div>
                <div class="btn-send">
                    <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">{{form.send_call_btn_desc}}</button>
                    <span class="error-message" v-show="errors.has('name') || errors.has('phone') || errors.has('email') || city == 'Ваш город'">{{errDesc}}</span>
                </div>
            </div>
            <div class="successMessage" v-if="!formVisible">
                <h3>Спасибо! Ваша заявка отправлена.</h3>
            </div>
        </form>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import {mapGetters} from 'vuex'
    import { Validator } from 'vee-validate';
    const dict = {
        custom: {
            email: {
                required: () => 'Введите ваш E-mail'
            },
            name: {
                required: () => 'Введите ваше имя'
            },
            phone: {
                required: () => 'Введите ваш номер телефона'
            }
        }
    };
    Validator.localize('ru', dict);
    export default {
        name: 'formCovid',
        data () {
            return {
                phone: '',
                name: '',
                city: 'Ваш город',
                admin_mail: '',
                agree: false,
                formVisible: true,
                errorMsg: false,
                errDesc: 'Заполните все поля',
                curIndex: 0,
                formGoogleParams: {
                    token: '',
                    dataForm: null,
                },
                cityArr: [
                    {
                        city: 'Ваш город',
                    },
                    {
                        city: 'Алматы',
                        token: '1FAIpQLScTrmJWOb4ALD81GNsdOgk49kexjWs71ZqnLEr5YSSixzgrxA',
                        dataForm: {
                            'entry.29190551' : this.name,
                            'entry.1733509131' : this.phone,
                            'entry.845574844': this.city,
                            
                        },
                        nameCode: 'entry.29190551',
                        phoneCode: 'entry.1733509131',
                        regionCode: 'entry.845574844',
                    },
                    {
                        city: 'Нур-Султан',
                        token: '1FAIpQLSdFf9MhWKTsDN1jwMMH0gMAGuHNEiKf1WlBU45evy4wnW_M4g',
                        dataForm: {
                            'entry.213969236' : this.name,
                            'entry.1241816797' : this.phone,
                            'entry.478070127': this.city,
                        },
                        nameCode: 'entry.213969236',
                        phoneCode: 'entry.1241816797',
                        regionCode: 'entry.478070127',
                    },
                    {
                        city: 'Шымкент',
                        token: '1FAIpQLSeZDsSeROkfVytXZIagyjIRhOYpNr7neuZ2l3qz1hENCeXk-g',
                        dataForm: {
                            'entry.1143360126' : this.name,
                            'entry.1465065096' : this.phone,
                            'entry.1212306411': this.city,
                        },
                        nameCode: 'entry.1143360126',
                        phoneCode: 'entry.1465065096',
                        regionCode: 'entry.1212306411',
                    },
                    {
                        city: 'Кызылорда',
                        token: '1FAIpQLSe-_JVV-FaIw39ikLPipakE8a4bCaqPUmtWhmh3HLNO9e3zoQ',
                        dataForm: {
                            'entry.279531996' : this.name,
                            'entry.819063136' : this.phone,
                            'entry.668519503': this.city,
                        },
                        nameCode: 'entry.279531996',
                        phoneCode: 'entry.819063136',
                        regionCode: 'entry.668519503',
                    },
                    {
                        city: 'Тараз',
                        token: '1FAIpQLScdAoJpxOjF_zG2NEd04Ab32vLliFOoAyHQBQTAik996PPg-w',
                        dataForm: {
                            'entry.1203169084' : this.name,
                            'entry.1566651556' : this.phone,
                            'entry.150869736': this.city,
                        },
                        nameCode: 'entry.1203169084',
                        phoneCode: 'entry.1566651556',
                        regionCode: 'entry.150869736',
                    },
                    {
                        city: 'Актау',
                        token: '1FAIpQLSejVQB8LyfXZWG0-rfBvGx5c0cXDpkAWwfpuxPA1d3oH7_c0A',
                        dataForm: {
                            'entry.800248701' : this.name,
                            'entry.1105795195' : this.phone,
                            'entry.1280884421': this.city,
                        },
                        nameCode: 'entry.800248701',
                        phoneCode: 'entry.1105795195',
                        regionCode: 'entry.1280884421',
                    },
                    {
                        city: 'Атырау',
                        token: '1FAIpQLSeSHbCqvurn1TrmtC6z37-ZdHkhOEhz3MLz1_yXSDrtXj4bqA',
                        dataForm: {
                            'entry.1158197343' : this.name,
                            'entry.1130533193' : this.phone,
                            'entry.772980647': this.city,
                        },
                        nameCode: 'entry.1158197343',
                        phoneCode: 'entry.1130533193',
                        regionCode: 'entry.772980647',
                    },
                    {
                        city: 'Караганда',
                        token: '1FAIpQLSeLDvzh2Mnbu66TGcrFErQWpPQzPJPbf846An704UWzF6Lxpg',
                        dataForm: {
                            'entry.1847274162' : this.name,
                            'entry.1673563558' : this.phone,
                            'entry.1136555974': this.city,
                        },
                        nameCode: 'entry.1847274162',
                        phoneCode: 'entry.1673563558',
                        regionCode: 'entry.1136555974',
                    },
                    {
                        city: 'Костанай',
                        token: '1FAIpQLSf3t0b_cdgCGGn02OQYUS7p77IismL2Cv-opwHFA5lhIt3ifQ',
                        dataForm: {
                            'entry.1361951388' : this.name,
                            'entry.2098368937' : this.phone,
                            'entry.4815220': this.city,
                        },
                        nameCode: 'entry.1361951388',
                        phoneCode: 'entry.2098368937',
                        regionCode: 'entry.4815220',
                    },
                    {
                        city: 'Павлодар',
                        token: '1FAIpQLSe9ijyyQkqFxXiKqb2JqP-HPFjp63LV9A3Kzwil5LrMAkkr1Q',
                        dataForm: {
                            'entry.1086757440' : this.name,
                            'entry.999700570' : this.phone,
                            'entry.34914947': this.city,
                        },
                        nameCode: 'entry.1086757440',
                        phoneCode: 'entry.999700570',
                        regionCode: 'entry.34914947',
                    },
                    {
                        city: 'Кокшетау',
                        token: '1FAIpQLScfPnzfrs-W60s3PwOzfh1tQZXIiaNF4QIGdniaiEzb5qhbaQ',
                        dataForm: {
                            'entry.534094559' : this.name,
                            'entry.2144793634' : this.phone,
                            'entry.2059867294': this.city,
                        },
                        nameCode: 'entry.534094559',
                        phoneCode: 'entry.2144793634',
                        regionCode: 'entry.2059867294',
                    },
                    {
                        city: 'Алматинская обл.',
                        token: '1FAIpQLSdGuWrl3_doFLBmBGnHlA_DjyPe56EFiaQ_xqEUY3UToUmsgw',
                        dataForm: {
                            'entry.799970265' : this.name,
                            'entry.343066088' : this.phone,
                            'entry.480291698': this.city,
                        },
                        nameCode: 'entry.799970265',
                        phoneCode: 'entry.343066088',
                        regionCode: 'entry.480291698',
                    },
                    {
                        city: 'Акмолинская обл.',
                        token: '1FAIpQLScTn79a-1BBOtt4lY9fb836f1fCOsgeS2D7MF8h8-BSWkz5dg',
                        dataForm: {
                            'entry.1598783892' : this.name,
                            'entry.423192381' : this.phone,
                            'entry.1263670048': this.city,
                        },
                        nameCode: 'entry.1598783892',
                        phoneCode: 'entry.423192381',
                        regionCode: 'entry.1263670048',
                    },
                ],
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                    mail: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
            MaskedInput,
        },
        computed: mapGetters({
            form: 'loadForms',
            currentCityArr: 'loadCurrentCityArr',
            // openFormConsult: 'loadOpenFormConsult',
            // formData: 'loadFormConsultData',
        }),
        methods: {
            sendData() {
                var querystring = require('querystring');
                var data = {
                    'admin': this.form.email_admin,
                    'name': this.name,
                    'phone': this.phone,
                    'city': this.city,
                };
                // console.log(data, 'form consult')
                // console.log(JSON.stringify(data));
                this.$validator.validate().then(result => {
                    if(result) {
                        if (this.city != 'Ваш город') {
                            this.formVisible = false
                            this.formGoogleParams.dataForm[this.cityArr[this.curIndex].nameCode] = this.name;
                            this.formGoogleParams.dataForm[this.cityArr[this.curIndex].phoneCode] = this.phone;
                            this.formGoogleParams.dataForm[this.cityArr[this.curIndex].regionCode] = this.city;
                            axios.post('/formSendSalesModal.php', querystring.stringify(data)).then(() => {
                                dataLayer.push({'event' : 'form_sent'})
                            });
                            $.ajax({
                                url: 'https://docs.google.com/forms/d/e/' + this.formGoogleParams.token + '/formResponse',
                                data: this.formGoogleParams.dataForm,
                                type: "POST",
                                dataType: "xml"
                            });
                            setTimeout(() => {
                                // this.closeForm();
                            }, 1500);
                        } else {
                            this.errDesc = 'Выберете город / регион'
                        }
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
                
            },
            closeForm() {
                this.$cookie.set('summerSalesModal', true, { expires: '1D' });
                this.$store.commit('openSalesModalAction', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open-sales-modal');
            },
            initSelectrick() {
                var _self = this;
                var select = $('#select-city'),
                    selectParent = $('.city-info-select');
                select.selectric();
                select.selectric({
                    onChange: function() {
                        // _self.city = $(this).val();\
                        _self.curIndex = parseInt($(this).val());
                        _self.city = _self.cityArr[$(this).val()].city;
                        _self.formGoogleParams.token = _self.cityArr[$(this).val()].token;
                        _self.formGoogleParams.dataForm = _self.cityArr[$(this).val()].dataForm;
                        console.log($(this), 'TEST')
                    },
                    onOpen: function() {
                        selectParent.addClass('open');
                    },
                    onClose: function() {
                        selectParent.removeClass('open');  
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getFormsData');
        },
        created () {
        },
        mounted () {
            this.initSelectrick();
            // this.$store.watch(
            //     (state) => state.forms,
            //     (newValue) => {
            //         if (newValue)
            //         this.admin_mail = this.form.admin_email
            //     }
            // )
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-covid.scss';
</style>